package org.vreo.devicehub.features.core.domain.device.device.anprDeviceSettings

/**
 * ANPR device settings
 *
 * @property updateType software update stability type
 */
data class AnprDeviceSettings(
    val updateType: AnprDeviceUpdateReleaseType = AnprDeviceUpdateReleaseType.STABLE,
    val enableDeviceHubReporting: Boolean = false,
)